import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AppViewReceiverConst } from 'src/app/Util/AppReceiver/AppViewReceiverConst';
import { BaseFragment } from 'src/app/View/BaseUI/BaseFragment';
import { ReserveFragmentController } from './ReserveFragmentController';
import {ReserveListPanelComponent} from './ReserveListPanel/ReserveListPanelComponent';
import {Router} from '@angular/router';
import {ReserveDetailPanelComponent} from './ReserveDetailPanel/ReserveDetailPanelComponent';
import {ReserveUpdateFragmentComponent} from './ReserveUpdatePanel/ReserveUpdateFragmentComponent';
/**
 * ReserveFragmentComponent
 * 予約画面
 */
@Component({
	selector: 'app-diagnose-component',
	templateUrl: './ReserveFragmentComponent.html',
	styleUrls: ['./ReserveFragmentComponent.scss'],
})
export class ReserveFragmentComponent extends BaseFragment {

	// パネルのコンテナ。各機能共通
	@ViewChild('panelContainer', {read: ViewContainerRef, static: false})
	private panelContainer: ViewContainerRef;


	// イベント設定
	private TARGET_CLASS_DEF = AppViewReceiverConst.User.Fragment.ReserveFragmentComponent;
	protected EVENT_LIST: Array<Array<any>> = [
		// 画面遷移用イベント。BaseFragmentに実装されているメソッドなので注意
		// スライドイン呼び出し
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.ChangeMovePanelView,
			this.changeMovePanelView.bind(this)
		],
		// スライドインした時に消えた前パネルを戻す
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.VisiblePanelView,
			this.visibleAllViewRef.bind(this)
		],
		// スライドインを閉じる
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.CloseMovePanelView,
			this.closeMovePanelView.bind(this)
		]
	];

	// スライドイン用のコンポーネント
	@ViewChild('slideMoveBaseContainer', { read: ViewContainerRef, static: false })
	public slideMoveBaseRef: ViewContainerRef;

	// 紐付いたコントローラー
	public combineCtrl: ReserveFragmentController;

	/**
	 * constructor
	 */
	constructor(
		public router: Router
	) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();

		// コントローラーの生成
		this.createController(ReserveFragmentController);

		this.router = router;
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();
		await this.onClickReservationList();
	}

	/**
	 * 一覧表示
	 * 詳細ページ表示メソッドを引き渡す
	 */
	public async onClickReservationList() {
		this.panelContainer.remove();
		const comp = await this.renewStartComponent(ReserveListPanelComponent, this.panelContainer);
		comp.eventShowDetail = this.showDetailView.bind(this);
	}

	/**
	 * 新規予約
	 */
	/*
	public async onClickReservationCreate() {
		await this.router.navigate(['/reserve']);
	}
	*/

	/**
	 * 詳細画面の表示
	 * @param reserveId
	 */
	public async showDetailView(reserveId: number): Promise<void> {
		this.panelContainer.remove();
		const comp = await this.renewStartWithInitialDataComponent(ReserveDetailPanelComponent, this.panelContainer, (comp) => {
			comp.reserveId = reserveId;
		});

		comp.eventClose = this.onClickReservationList.bind(this);
		comp.eventShowUpdateView = this.showUpdateView.bind(this);
	}

	/**
	 * 更新画面の表示
	 * @param reserveId
	 */
	public async showUpdateView(reserveId: number): Promise<void> {
		this.panelContainer.remove();
		const comp = await this.renewStartWithInitialDataComponent(ReserveUpdateFragmentComponent, this.panelContainer, (comp: ReserveUpdateFragmentComponent) => {
			comp.reserveId = reserveId;
		});

		comp.eventShowDetailView = this.showDetailView.bind(this);
	}

}

